module.exports = __webpack_public_path__ + "img/favourite.96520253.svg";